import React from "react";
import { useUser, UserRole } from "../../../../services/UserContext";
import EditButton from "../../../utils/buttons/EditButton";
import DeleteButton from "../../../utils/buttons/DeleteButton";
import useAnimation from "../../../../services/functions/useAnimation";

interface CardProps {
  id: number;
  title: string;
  description: string;
  thumbnail: number;
  setVisible: React.Dispatch<
    React.SetStateAction<{
      index: number;
      title: string;
      visible: boolean;
    }>
  >;
}

const Card: React.FC<CardProps> = ({
  id,
  title,
  description,
  thumbnail,
  setVisible,
}) => {
  const { slideOutItem } = useAnimation();
  const { role } = useUser();

  // Use environment variable from .env-file
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  // Check if the user has permission (Admin or Editor)
  const canEdit = role === UserRole.ADMIN || role === UserRole.EDITOR;

  return (
    <>
      <div className="card__item" onDragStart={(e) => e.preventDefault()}>
        <div className="card__body">
          {canEdit && (
            <div className="icon-container">
              <div
                onClick={async (e) => {
                  e.stopPropagation();
                  await slideOutItem(
                    ".card__wrapper",
                    id.toString(),
                    `/edit?id=${id}`
                  );
                }}
              >
                <EditButton onEdit={() => {}} />
              </div>
              <div onClick={(e) => e.stopPropagation()}>
                <DeleteButton
                  onDelete={() => {
                    setVisible({ index: id, title: title, visible: true });
                  }}
                />
              </div>
            </div>
          )}
          <img
            src={`${apiBaseUrl}/pic/${thumbnail}`}
            alt={title}
            className="card__image"
          />
          <div className="card__content">
            <h2 className="card__content__title">{title}</h2>
            <p className="card__content__description">
              {description.slice(0, 120) + " ..."}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;
